import React, { Component } from 'react';
import { Input } from 'antd';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { fetchZipCodeData, flushZipCode, resetAllZipFields } from './actions';
import ToJS from '../../Epics/Grants/Pages/GrantsDashboard/components/HOC/toJS';
import { getZipCodeDetails } from '../../utils/commonUtil';
import { zipCodeData } from './selectors';

export class Zipcode extends Component {
  componentWillUnmount() {
    this.props.flushZipCode();
  }

  showError = zipTitle => {
    this.props.resetAllZipFields(zipTitle);
    return false;
  };

  getZipCodeStatus = (zipCode, zipTitle) => {
    if (zipCode.length === 5) {
      return zipCode.indexOf('-') === -1 ? true : this.showError(zipTitle);
    }
    if (zipCode.length === 10) {
      return zipCode.indexOf('-') === 5 && zipCode.split('-').length === 2
        ? true
        : this.showError(zipTitle);
    } else {
      return this.props.isUS ? this.showError(zipTitle) : false;
    }
  };

  checkZipCodeOnBlur = e => {
    this.props.onBlur(e);
  };

  getZipCode = e => {
    const zipCode = e.target.value;
    const zipTitle = e.target.title;
    if (this.props.isUS && this.getZipCodeStatus(zipCode, zipTitle)) {          
      getZipCodeDetails(zipCode)
        .then((response) => {
          this.props.getZipCode(zipTitle, response);
        })
        .catch((err) => console.log(err));
    }
    this.props.onChange(e);
  };

  render() {
    const {
      name,
      title,
      maxLength,
      placeholder,
      id,
      value,
      className,
      ariaLabel
    } = this.props;
    return (
      <Input
        aria-label={ariaLabel ? ariaLabel : "Zipcode"}
        id={id}
        name={name}
        className={className ? className : ''}
        title={title}
        onChange={this.getZipCode}
        placeholder={placeholder}
        data-test="common-zip-code"
        onBlur={e => this.checkZipCodeOnBlur(e)}
        maxLength={maxLength ? parseInt(maxLength) : null}
        value={value}
      />
    );
  }
}

Zipcode.propTypes = {
  className: PropTypes.string,
  flushZipCode: PropTypes.func,
  getZipCode: PropTypes.func,
  id: PropTypes.string,
  isUS: PropTypes.bool,
  maxLength: PropTypes.any,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  resetAllZipFields: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.string
}

const mapStateToProps = state => ({
  zipCode: zipCodeData(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  getZipCode: (zipTitle, data) => dispatch(fetchZipCodeData(zipTitle, data)),
  flushZipCode: () => dispatch(flushZipCode()),
  resetAllZipFields: zipTitle => dispatch(resetAllZipFields(zipTitle))
});

export default ToJS(connect(mapStateToProps, mapDispatchToProps)(Zipcode));
